import { MealOfDayDivision, TempMealOfDayDivision } from '@/api/types'
import { SORTED_MEALS } from '@/features/meal-recommendations/constants'
import { TFunction } from 'i18next'

export function groupBy<T>(
  array: T[],
  key: string,
): {
  [key: string]: T[]
} {
  return array.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export function roundNumber(value: number, numberOfDecimalPlaces = 0) {
  const decPlaces = 10 ** numberOfDecimalPlaces

  return Math.round(value * decPlaces) / decPlaces
}

export function debounce<A = unknown, R = void>(func: (args: A) => R, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export function roundObjectValues<T extends Record<string, number>>(obj: T): T {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    ;(acc as Record<string, number>)[key] = Math.round(value)
    return acc
  }, {} as T)
}

export function getSelectedMealsFromMealDivisions(mealDivisions: MealOfDayDivision[]) {
  return SORTED_MEALS.filter((meal) => mealDivisions.some((md) => md.mealOfDay === meal)).map(
    (meal) => ({ mealOfDay: meal }),
  )
}

export function getMealOfDayDivisionName(mod: TempMealOfDayDivision, t?: TFunction) {
  if (mod.type === 'MEAL_PART') {
    return t ? t(`mealParts.${mod.mealPart}` as any) : mod.mealPart
  }
  if (mod.type === 'RECIPE') {
    return mod.recipe?.name
  }
  if (mod.type === 'INGREDIENT') {
    return mod.ingredientDivision?.ingredient?.name
  }
  return ''
}
